export default function Menu() {
  return <div>Notifications</div>;
}